import { Stack, StackProps, styled } from '@mui/material';
import clsx from 'clsx';

import { Scroller } from '../scroller';
import { tokens } from '../../theme/generated/tokens';

const Body = styled(Stack)({
  paddingBottom: 16,

  '& .DS-Drawer-Footer': {
    backgroundColor: tokens.theme.bg.structural.surface,
    borderTop: 'none',
    paddingTop: 24,
  },
});

type Props = StackProps & {
  testId?: string;
};

export const DrawerBody = ({ testId, className, ...props }: Props) => {
  return (
    <Scroller sx={{ flex: 1 }}>
      <Body
        {...props}
        className={clsx('DS-Drawer-Body', className)}
        data-testid={testId}
      />
    </Scroller>
  );
};
